/* ══════════════════════════════════════════════════════════════════════════════════════════════
   Seitenweite Fenster der Standardkarte (08.10.; Markup snippets/rd-dialoge.liquid, Stil rd-system.css).
   1. Benachrichtigen (data-rd-bis="<Varianten-ID>" an der Karte): Produktkopf aus der Karte, Klaviyo Back-in-Stock,
      optional Newsletter (eigenes Häkchen, Double-Opt-in), dazu eine lieferbare ähnliche Sorte (gleiche Farbe, nächster
      Zuckerwert – nur intern, keine Zahl) von derselben Seite, sonst aus Shopifys Empfehlungen.
   2. Zutaten & Nährwerte (data-rd-lmiv="<Produkt-URL>"): Angaben der Produktseite (Vorlage product.rd-lmiv) neu geordnet.
   window.rdBis.subscribe() nutzt auch das Formular auf der Produktseite (snippets/rd-pdp-blocks.liquid).
   22.10.2026: Newsletter-Teil ohne profile.subscriptions – Klaviyo (revision 2024-10-15) lehnte die Anmeldung damit mit 400 ab
   („'subscriptions' is not a valid field“), das Häkchen „Auch den Newsletter“ trug seit 08.10. niemanden ein.
   ══════════════════════════════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.rdBis) return;
  var CO = 'Vs5ixY', LIST = 'QTFtwP', REV = '2024-10-15';
  var H = { 'Content-Type': 'application/json', revision: REV };
  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + CO, { method: 'POST', headers: H, body: JSON.stringify(body) });
  }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  window.rdBis = {
    /* Promise → { nl: true | false }; wirft, wenn die Benachrichtigung selbst nicht klappt */
    subscribe: function (mail, variant, nl, source) {
      return post('back-in-stock-subscriptions', { data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: mail } } } }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } } } } })
        .then(function (r) {
          if (!r.ok) throw new Error('bis ' + r.status);
          track('rd_bis_signup', { variant_id: String(variant), newsletter: !!nl });
          if (!nl) return { nl: false };
          return post('subscriptions', { data: { type: 'subscription', attributes: { custom_source: source || 'Back in Stock', profile: { data: { type: 'profile', attributes: { email: mail } } } }, relationships: { list: { data: { type: 'list', id: LIST } } } } })
            .then(function (r2) { return { nl: r2.ok }; }, function () { return { nl: false }; });
        });
    },
    valid: function (mail) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail); }
  };

  var esc = function (s) { var x = document.createElement('div'); x.textContent = s || ''; return x.innerHTML; };
  var txt = function (root, sel) { var el = root && root.querySelector(sel); return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; };
  var preview = function () { return !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main'); };
  var money = function (c) { return (c / 100).toFixed(2).replace('.', ',') + '\u00a0€'; };
  function open(d) { if (d && d.showModal && !d.open) d.showModal(); }

  /* ── 1. Benachrichtigen ─────────────────────────────────────────────────────────────────────── */
  function setAlt(f, a) {
    var box = f.querySelector('[data-rd-bis-alt]');
    if (!a) { box.hidden = true; return; }
    f.querySelector('[data-rd-bis-altlink]').href = a.url;
    var im = f.querySelector('[data-rd-bis-altimg]'); im.src = a.img || ''; im.parentNode.hidden = !a.img;
    f.querySelector('[data-rd-bis-altmarke]').textContent = a.marke || '';
    f.querySelector('[data-rd-bis-altname]').textContent = a.name || '';
    f.querySelector('[data-rd-bis-altpreis]').textContent = a.preis || '';
    box.hidden = false;
  }
  /* Alternative (08.10. User: „sehr nice“, aber „smart und sauber“): gleiche Kategorie (rd-kat), höchstens 25 % bzw. 5 € teurer
     (Ersatz wirkt nur, wenn er nicht teurer ist: Breugelmans 2006), keine Sets; Rangfolge gleiche Farbe → nächster Zucker → Preisnähe */
  function priceCap(p) { return p > 0 ? Math.max(p * 1.25, p + 500) : Infinity; }
  function altFromPage(card) {
    var best = null, bs = 1e12, zf = card ? parseFloat(card.dataset.zucker) : NaN, ff = card ? (card.dataset.farbe || '') : '', pid = card ? card.dataset.rdPid : '';
    var kat = card ? (card.dataset.kat || '') : '', pr = card ? parseInt(card.dataset.preis || '0', 10) : 0, cap = priceCap(pr);
    document.querySelectorAll('.rd-karte:not(.is-aus)').forEach(function (c) {
      if (c === card || c.dataset.rdPid === pid || c.dataset.set === '1' || (c.dataset.kat || '') === 'set') return;
      if (c.closest('dialog, header, [id$="__header"], .predictive-search, .drawer')) return;
      if (kat && kat !== 'sonst' && c.dataset.kat && c.dataset.kat !== kat) return;
      var cp = parseInt(c.dataset.preis || '0', 10); if (cp > cap) return;
      var z = parseFloat(c.dataset.zucker), dz = isNaN(zf) || isNaN(z) ? 50 : Math.abs(z - zf);
      var score = ((c.dataset.farbe || '') === ff ? 0 : 1e9) + dz * 1000 + Math.abs(cp - pr) / 100;
      if (score < bs) { bs = score; best = c; }
    });
    if (!best) return null;
    var l = best.querySelector('.rd-karte__link'), im = best.querySelector('.rd-karte__bild img');
    return l ? { url: l.href, img: im ? (im.currentSrc || im.src) : '', marke: txt(best, '.rd-karte__marke'), name: l.textContent.trim(), preis: txt(best, '.rd-karte__p b') } : null;
  }
  function altFromReco(pid, f, token) {
    if (!pid || !window.fetch) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=8&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        if (f.dataset.token !== token) return;
        var cap = priceCap(parseInt(f.dataset.preis || '0', 10));
        var p = (j.products || []).filter(function (x) { return x.available && String(x.id) !== String(pid) && x.price <= cap && !/probier|tasting|set\b|box\b|paket/i.test(x.title); })[0];
        if (!p) return;
        var name = p.title.split(' - ')[0].replace(/\s+alkoholfrei.*$/i, '').trim();
        var img = p.featured_image ? (String(p.featured_image).indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        var au = new URL(p.url, location.origin); if (preview()) au.searchParams.set('view', 'redesign-v2');
        setAlt(f, { url: au.pathname + au.search, img: img, marke: p.vendor, name: name, preis: money(p.price) });
      }).catch(function () {});
  }
  function openBis(btn) {
    var d = document.getElementById('rd-dlg-bis'); if (!d) return false;
    var f = d.querySelector('form'), card = btn.closest('.rd-karte');
    f.dataset.variant = btn.getAttribute('data-rd-bis');
    f.dataset.preis = card ? (card.dataset.preis || '0') : '0';
    f.dataset.token = String(Date.now());
    f.querySelector('[data-rd-bis-name]').textContent = btn.getAttribute('data-name') || txt(card, '.rd-karte__name');
    f.querySelector('[data-rd-bis-marke]').textContent = btn.getAttribute('data-marke') || txt(card, '.rd-karte__marke');
    f.querySelector('[data-rd-bis-preis]').textContent = btn.getAttribute('data-preis') || [txt(card, '.rd-karte__p b'), txt(card, '.rd-karte__preis small')].filter(Boolean).join(' · ');
    var im = card && card.querySelector('.rd-karte__bild img'), fi = f.querySelector('[data-rd-bis-img]');
    var src = btn.getAttribute('data-img') || (im ? (im.currentSrc || im.src) : '');
    if (src) { fi.src = src; fi.parentNode.hidden = false; } else { fi.parentNode.hidden = true; }
    var alt = altFromPage(card); setAlt(f, alt);
    if (!alt) altFromReco(card ? card.dataset.rdPid : btn.getAttribute('data-pid'), f, f.dataset.token);
    f.classList.remove('is-done', 'is-error');
    var inp = f.querySelector('input[type=email]'); inp.disabled = false;
    var ok = f.querySelector('.rd-kol-bisf__ok'); ok.disabled = false; ok.textContent = 'Benachrichtigen';
    f.querySelector('[data-rd-bis-note]').textContent = 'Ohne Häkchen bekommst du nur diese eine E-Mail.';
    var nl = f.querySelector('[data-rd-bis-nl]'); if (nl) { nl.checked = true; nl.disabled = false; }
    open(d); track('rd_bis_open', { variant_id: f.dataset.variant });
    return true;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('#rd-dlg-bis form')) return;
    e.preventDefault();
    var inp = f.querySelector('input[type=email]'), ok = f.querySelector('.rd-kol-bisf__ok'), note = f.querySelector('[data-rd-bis-note]'), nl = f.querySelector('[data-rd-bis-nl]');
    var mail = (inp.value || '').trim();
    if (!window.rdBis.valid(mail)) { f.classList.add('is-error'); note.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.'; inp.focus(); return; }
    ok.disabled = true; ok.textContent = '…';
    var wantNl = !!(nl && nl.checked);
    window.rdBis.subscribe(mail, f.dataset.variant, wantNl, 'Back in Stock (Karte)').then(function (res) {
      var msg = 'Eingetragen. Du bekommst eine E-Mail, sobald die Sorte wieder da ist.';
      if (wantNl) msg += res.nl ? ' Für den Newsletter kommt gleich noch eine Mail: bitte kurz bestätigen.' : ' Die Newsletter-Anmeldung hat gerade nicht geklappt, das geht jederzeit unten auf der Seite.';
      if (nl) nl.disabled = true;
      f.classList.remove('is-error'); f.classList.add('is-done'); note.textContent = msg; inp.disabled = true; ok.textContent = 'Eingetragen';
    }).catch(function () {
      ok.disabled = false; ok.textContent = 'Benachrichtigen'; f.classList.add('is-error'); note.textContent = 'Das hat gerade nicht geklappt. Bitte versuch es gleich noch einmal.';
    });
  });

  /* ── 2. Zutaten & Nährwerte ─────────────────────────────────────────────────────────────────── */
  /* Angaben einer Produktseite (Vorlage product.rd-lmiv) als HTML: Zutaten · Nährwerte · Weitere Angaben (Lücken raus) */
  /* 09.10. (User: „Zutaten & Nährwerte laden erst beim Klick“): Ergebnis je URL zwischenspeichern und beim Drüberfahren bzw.
     Antippen schon vorladen – beim Klick ist es dann meist sofort da */
  var lmivCache = {};
  function lmivHtml(url) {
    var key = String(url).split('?')[0].split('#')[0];
    if (!lmivCache[key]) lmivCache[key] = lmivLoad(url).catch(function (e) { delete lmivCache[key]; throw e; });
    return lmivCache[key];
  }
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var l = e.target && e.target.closest && e.target.closest('[data-rd-lmiv]');
      if (l && l.dataset.rdLmiv && window.fetch) lmivHtml(l.dataset.rdLmiv).catch(function () {});
    }, { capture: true, passive: true });
  });
  function lmivLoad(url) {
    var lu = new URL(url, location.origin); lu.search = ''; lu.searchParams.set('view', 'rd-lmiv');
    return fetch(lu.toString()).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector('#rd-lmiv');
      if (!src) throw new Error('leer');
      var rows = {}, order = [];
      src.querySelectorAll('.rd-v2z__row').forEach(function (r) {
        if (r.querySelector('.rd-v2z__gap')) return;
        var dt = r.querySelector('dt'), dd = r.querySelector('dd'); if (!dt || !dd) return;
        var k = dt.textContent.trim(); rows[k] = dd.innerHTML; order.push(k);
      });
      var out = '';
      if (rows['Zutaten']) out += '<div class="rd-lm-sec"><p class="rd-lm-lbl">Zutaten</p><p class="rd-lm-zut">' + rows['Zutaten'] + '</p>' + (rows['Allergene'] ? '<p class="rd-lm-all"><b>Allergene:</b>&nbsp;' + rows['Allergene'] + '</p>' : '') + '</div>';
      var nw = src.querySelectorAll('.rd-v2z__nwrow');
      if (nw.length) {
        var basis = src.querySelector('.rd-v2z__basis'), note = src.querySelector('.rd-v2z__nwnote');
        out += '<div class="rd-lm-sec"><p class="rd-lm-lbl">Nährwerte<span>' + esc(basis ? basis.textContent.trim() : '') + '</span></p><table class="rd-lm-nw"><tbody>';
        nw.forEach(function (r) { var c = r.querySelectorAll('span'); if (c.length < 2) return; out += '<tr' + (r.classList.contains('rd-v2z__nwrow--sub') ? ' class="is-sub"' : '') + '><td>' + esc(c[0].textContent.trim()) + '</td><td>' + esc(c[1].textContent.trim()) + '</td></tr>'; });
        out += '</tbody></table>' + (note ? '<p class="rd-lm-note">' + esc(note.textContent.trim()) + '</p>' : '') + '</div>';
      }
      var facts = '';
      order.forEach(function (k) {
        if (k === 'Zutaten' || k === 'Allergene') return;
        facts += '<div' + (/Verkehrsbezeichnung|Lebensmittelunternehmer|haltbar/i.test(k) ? ' class="is-wide"' : '') + '><dt>' + esc(k) + '</dt><dd>' + rows[k] + '</dd></div>';
      });
      if (facts) out += '<div class="rd-lm-sec"><p class="rd-lm-lbl">Weitere Angaben</p><dl class="rd-lm-facts">' + facts + '</dl></div>';
      if (!out) throw new Error('leer');
      return out;
    });
  }

  function openLmiv(a) {
    var d = document.getElementById('rd-dlg-lmiv'); if (!d || !d.showModal || !window.fetch) return false;
    var body = d.querySelector('[data-rd-lmiv-body]');
    d.querySelector('[data-rd-lmiv-pdp]').href = (a.getAttribute('href') || '#').split('#')[0];
    var card = a.closest('.rd-karte'), im = card && card.querySelector('.rd-karte__bild img');
    var head = '<div class="rd-lm-prod">' + (im ? '<span class="rd-lm-prod__img"><img src="' + (im.currentSrc || im.src) + '" alt=""></span>' : '<span></span>') + '<span><span class="rd-lm-prod__m">' + esc(txt(card, '.rd-karte__marke')) + '</span><span class="rd-lm-prod__n">' + esc(a.dataset.name) + '</span></span></div>';
    body.innerHTML = head + '<p class="rd-kol-lmiv__laden">Lädt …</p>';
    open(d);
    lmivHtml(a.dataset.rdLmiv).then(function (out) { body.innerHTML = head + out; })
      .catch(function () { body.innerHTML = head + '<p class="rd-kol-lmiv__laden">Die Angaben stehen auf der Produktseite.</p>'; });
    track('rd_lmiv_open', { url: a.dataset.rdLmiv });
    return true;
  }

  /* 08.10. Sets: Zutaten & Nährwerte je Flasche in der Produktseite (<details data-rd-lmiv-inline="<Pfad>">), geladen beim Aufklappen */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details[data-rd-lmiv-inline]') || !d.open || d.dataset.rdGeladen) return;
    d.dataset.rdGeladen = '1';
    var ziel = d.querySelector('[data-rd-lmiv-ziel]'); if (!ziel || !window.fetch) return;
    var url = d.getAttribute('data-rd-lmiv-inline');
    lmivHtml(url).then(function (out) { ziel.innerHTML = out; })
      .catch(function () { ziel.innerHTML = '<p class="rd-kol-lmiv__laden">Die Angaben stehen auf der <a href="' + url + '">Seite der Sorte</a>.</p>'; });
    track('rd_lmiv_open', { url: url, set: 1 });
  }, true);

  /* ── Klicks (eine Stelle für alle Seiten) ───────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var b = t.closest('[data-rd-bis]'); if (b && b.tagName === 'BUTTON') { if (openBis(b)) e.preventDefault(); return; }
    var l = t.closest('[data-rd-lmiv]'); if (l) { if (openLmiv(l)) e.preventDefault(); return; }
    var z = t.closest('[data-rd-dlg-zu]'); if (z) { z.closest('dialog').close(); return; }
    if (t.tagName === 'DIALOG' && (t.id === 'rd-dlg-bis' || t.id === 'rd-dlg-lmiv')) t.close();
  });
})();
